import DropdownMenu from '@pelckmans/elementis/components/dropdown-menu';
import Pill from '@pelckmans/elementis/components/pill';
import { useBreakpoint } from '@pelckmans/elementis/contexts/BreakpointsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AccountContext from '../../../contexts/AccountContext';
import { capitalize } from '../../../utils/string';
import { useRoutes } from '../../../hooks/useRoutes';
import { useIanuaLogout } from '../../../hooks/useLogout';

type UserMenuProps = {
  referenceEl: HTMLElement | null;
};

function UserMenu({ referenceEl }: UserMenuProps) {
  const { t } = useTranslation();
  const {
    account: { role, firstName, lastName },
  } = useContext(AccountContext);

  const logout = useIanuaLogout();

  const { getRoute } = useRoutes();

  const breakpoint = useBreakpoint();

  return (
    <DropdownMenu
      referenceEl={referenceEl}
      menuProps={{ ariaLabel: t('APP_NAV.SIDE_NAV.USER_MENU.A11Y_LABEL'), id: 'user-menu' }}
      role="menu"
      placement={breakpoint === 'mobile' ? 'bottom-end' : 'right-end'}
      offset={20}
      grow
      showSeparators
    >
      <DropdownMenu.Item
        as="link"
        href={`/ianua/${getRoute('MY_PROFILE')}`}
        value={null}
        role="menuitem"
        text={`${firstName} ${lastName}`.trim()}
        subText={t('APP_NAV.SIDE_NAV.USER_MENU.EDIT')}
        pillGroupProps={{
          role: 'group',
          'aria-label': undefined,
          children: <Pill key={1}>{capitalize(t(role))}</Pill>,
        }}
      />
      <DropdownMenu.Item
        as="link"
        href={`/ianua/${getRoute('HELP')}`}
        value={null}
        role="menuitem"
        text={t('APP_NAV.SIDE_NAV.USER_MENU.HELP')}
      />
      <DropdownMenu.Item
        onClick={logout}
        value={null}
        role="menuitem"
        text={t('APP_NAV.SIDE_NAV.USER_MENU.SIGN_OUT')}
        prominence="danger"
      />
    </DropdownMenu>
  );
}

export default UserMenu;
